import { showMessage } from '../actions';

export const CreateApiHandler = (callback, actionType, options={}) => {

  const defaultOptions = {
    errorMessage: '',
    showErrorSnackbar: true,
  }

  const mergedOptions = {...defaultOptions, ...options}

    return (...props) => (dispatch) => {
       return new Promise(async (res, rej) => {
                        try{
                          dispatch({type: actionType}) 
                          const response = await callback(...props);
                          dispatch({type: `${actionType}_SUCCESS`, payload: response}) 
                          res(response)
                        }catch(err){
                            mergedOptions.showErrorSnackbar && showMessage({
                               message: mergedOptions.errorMessage || "Some error occured. Please contact support@hiverhq.com",
                               type: "error",
                             });
                             dispatch({type: `${actionType}_FAILED`, error: err}) 
                             rej(err);
                        }
                      
                })
    } 
 }